import React from "react";
import elephantPng from "../assets/elephnatandogsImg.png";
import Pattern from "../assets/pattern (5).png";

const WhyUs = () => {
  return (
    <div id="whyus" className=" bg-warm-yellow text-center md:text-left relative">
      <div className="px-8 md:px-16 pb-0 md:pb-20 pt-20 z-20">
        <div className="pb-8 text-3xl md:text-6xl font-bold">
          <h1>Why Choose  <span className="elephonkHeading">Elephonk</span></h1>
        </div>
        <div className="w-full relative z-20">
          <ul className="md:list-disc md:pl-8 space-y-8 md:w-[50%] z-20">
            <div className="border-b border-primary pb-4 md:pl-2 md:py-2">
              <li className="font-bold text-lg md:text-2xl">Join The Pack</li>
              <p className="opacity-70">
                Become part of the memecoin movement on Solana
              </p>
            </div>
            <div className="border-b border-primary pb-4 md:pl-2 md:py-2">
              <li className="font-bold text-lg md:text-2xl">
                First on Solana with Utilities
              </li>
              <p className="opacity-70">
                ELEPHONK stands out as the first memecoin on Solana with a range
                of utilities.
              </p>
            </div>
            <div className="border-b border-primary pb-4 md:pl-2 md:py-2">
              <li className="font-bold text-lg md:text-2xl">
                Movement Uniting Dog Lovers and Crypto Enthusiasts
              </li>
              <p className="opacity-70">
                ELEPHONK bridges the gap between the love for dogs and the world
                of cryptocurrency.
              </p>
            </div>
            <div className="border-b border-primary pb-4 md:pl-2 md:py-2">
              <li className="font-bold text-lg md:text-2xl">
                Solana's Pumping Trend
              </li>
              <p className="opacity-70">
                Solana's crazy growth and low transaction fees make it the ideal
                chain for ELEPHONK.
              </p>
            </div>
            <div className="border-b border-primary pb-4 md:pl-2 md:py-2">
              <li className="font-bold text-lg md:text-2xl">Other Dog Memes</li>
              <p className="opacity-70">
                Some dog memes on Solana with multi-million market caps include
                $BONK, $MYRO, $WIF, $SAMO.
              </p>
            </div>
          </ul>
        </div>
      </div>

      <div>
        <img
          src={elephantPng}
          alt=""
          className=" md:absolute md:h-[70%] right-0 bottom-0 z-10"
        />
      </div>
    </div>
  );
};

export default WhyUs;
